<template>
  <div
    v-if="visibleAccordion"
    class="accordion-vat-increase-notify"
  >
    <Accordion
      header-color="rgba(255, 145, 0, 0.1)"
      :need-close-icon="true"
      class="accordion-vat-increase-notify__accordion"
      @close="onClose"
    >
      <template v-slot:header>
        <div class="accordion-vat-increase-notify__header">
          <MIcon
            :icon="warningFilled"
            class="accordion-vat-increase-notify__header-icon"
          />
          <span class="accordion-vat-increase-notify__header-text">
            {{ headerText }}
          </span>
        </div>
      </template>
      <template v-slot:content>
        <div class="accordion-vat-increase-notify__wrapper">
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="accordion-vat-increase-notify__text"
            v-html="text"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script>
  import warningFilled from 'assets/icons/warning-filled.svg';
  import {Accordion} from '@marilyn/marilyn-ui';
  import {SELLER_META_VAT_INCREASE_NOTIFY_VIEWED_2026} from 'utils/seller/sellerMetaUtils';
  import {SET_META_USER as SET_META_USER_SELLER} from 'store/modules/seller/sellerUser';
  import {SET_META_USER} from 'store/modules/user/user';
  import {isCurrentAppSeller, isCurrentAppDefault} from 'utils/appTypeState';
  import moment from 'moment';

  export default {
    name: 'AccordionVATIncreaseNotify',
    components: {
      Accordion
    },
    data () {
      return {
        warningFilled,
        showAccordionLocal: true
      };
    },
    computed: {
      visibleAccordion () {
        return !this.isVATIncreaseNotifyViewed && this.showAccordionLocal && this.text && this.isNotAfter15January2026;
      },
      isNotAfter15January2026 () {
        return !moment().isAfter('2026-01-15');
      },
      headerText () {
        if (isCurrentAppSeller()) {
          return 'С 1 января 2026 сервис будет учитывать повышенный НДС 22% на рекламу';
        } else if (isCurrentAppDefault()) {
          return 'С 1 января 2026 статистика по всем модулям будет учитывать НДС 22% на рекламу';
        }

        return null;
      },
      text () {
        if (isCurrentAppSeller()) {
          return 'Ставки вырастут на 2%, как и стоимость показов и кликов на маркетплейсе. Цена за сервис останется прежней.';
        } else if (isCurrentAppDefault()) {
          return 'С&nbsp;повышением НДС&nbsp;вырастут на&nbsp;2% ставки в&nbsp;группах бид-менеджера и&nbsp;значения в&nbsp;группах балансировки и&nbsp;ограничений бюджетов. Если&nbsp;хотите сохранить старые ставки и&nbsp;бюджеты, измените настройки до&nbsp;31&nbsp;декабря. Цена за&nbsp;систему останется прежней.';
        }

        return null;
      },
      isVATIncreaseNotifyViewed () {
        const isSellerRouteAllowed = this.$route && ['sellerStatistics', 'sellerHome'].includes(this.$route.name);

        if (isCurrentAppSeller() && isSellerRouteAllowed) {
          return this.$store.getters['sellerUser/isVATIncreaseNotifyViewed2026'];
        } else if (isCurrentAppDefault()) {
          return this.$store.getters['user/isVATIncreaseNotifyViewed2026'];
        }

        return true;
      }
    },
    methods: {
      onClose () {
        if (isCurrentAppSeller()) {
          this.$store.dispatch(
            `sellerUser/${SET_META_USER_SELLER}`,
            {[SELLER_META_VAT_INCREASE_NOTIFY_VIEWED_2026]: true}
          );
        } else if (isCurrentAppDefault()) {
          this.$store.dispatch(
            `user/${SET_META_USER}`,
            {[SELLER_META_VAT_INCREASE_NOTIFY_VIEWED_2026]: true}
          );
        }

        this.showAccordionLocal = false;
      }
    }
  };
</script>

<style scoped>
  .accordion-vat-increase-notify {
    width: 760px;
  }

  .accordion-vat-increase-notify__header {
    display: flex;
    align-items: center;
  }

  .accordion-vat-increase-notify__header-icon {
    color: #FF9100;

    flex-shrink: 0;

    width: 18px;
    height: 18px;

    margin-right: 8px;
  }

  .accordion-vat-increase-notify__header-text {
    font-family: var(--font-primary, 'Roboto');
    font-size: 12px;
    font-weight: 700;

    color: #242424;
    line-height: 20px;

    letter-spacing: normal;

    margin: 0;
  }

  .accordion-vat-increase-notify__wrapper {
    font-family: var(--font-primary, 'Roboto');
    font-size: 12px;
    font-weight: 400;

    color: #191919;
    line-height: 1.2;

    letter-spacing: normal;

    display: flex;

    flex-direction: column;

    margin: 0;
  }
</style>
